'use client';

import { cn } from '@/lib/utils';
import { NeuCheckbox } from '@hcahealthcaredpx/neutron-react';

import { useListingContext } from '../../hooks';
import styles from '../../listing.module.css';

export const LanguagesFilter = (): JSX.Element => {
  const { languages, selectedLanguages, toggleSelectedLanguages } = useListingContext();

  return (
    <div className={cn('my-3', styles.languagesWrapper)}>
      {languages?.map((lang) => {
        return (
          <NeuCheckbox
            key={lang}
            label={lang}
            value={lang}
            checked={selectedLanguages.includes(lang)}
            onNeuChange={() => toggleSelectedLanguages(lang ?? '')}
          />
        );
      })}
    </div>
  );
};
